import { useEffect, useState } from 'react';
import styled from 'styled-components';

import nextIcon from '../icons/ic-next-list.png';
import prevIcon from '../icons/ic-prev-list.png';

/**
 *
 * @param {number} totalItems 총 item 개수
 * @param {function} paginate 페이지 변경 함수
 * @param {function} handleNextPageGroup 다음 페이지 그룹에서 실행할 함수 (optional)
 * @param {number} pageCount 목록에서 보여줄 페이지 개수 (optional - default: 5)
 */
function Pagination({
  itemsPerPage,
  totalItems,
  paginate,
  currentPage,
  handleNextPageGroup,
  pageCount = 5,
}) {
  const pageNumbers = [];
  const totalPage = Math.ceil(totalItems / itemsPerPage);
  const [pageGroup, setPageGroup] = useState(
    Math.ceil(currentPage / pageCount)
  );
  const firstPage = (pageGroup - 1) * pageCount + 1;
  const lastPage = pageGroup * pageCount;
  const [loadedPageGroup, setLoadedPageGroup] = useState([]);
  for (let i = firstPage; i <= lastPage; i++) {
    if (i > totalPage) break;
    pageNumbers.push(i);
  }

  useEffect(() => {
    setPageGroup(Math.ceil(currentPage / pageCount));
  }, [currentPage, pageCount]);

  const handlePrevBtn = () => {
    if (currentPage !== 1) {
      paginate(currentPage - 1);
    }
  };

  const handleNextBtn = () => {
    if (currentPage !== totalPage) {
      paginate(currentPage + 1);
      if (currentPage === lastPage) {
        if (!loadedPageGroup.includes(pageGroup + 1) && handleNextPageGroup) {
          setLoadedPageGroup([...loadedPageGroup, pageGroup + 1]);
          handleNextPageGroup();
        }
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {totalItems !== 0 && (
        <>
          <Button onClick={handlePrevBtn}>
            <img
              src={prevIcon}
              alt="이전"
              style={{ marginRight: 7, paddingTop: 3 }}
            />
            <p style={{ marginRight: 20 }}>이전</p>
          </Button>

          {pageNumbers.map((number) => (
            <div
              key={number}
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginRight: 5,
                border: currentPage === number ? '2px solid #FF7A00' : 'none',
                cursor: 'pointer',
              }}
              onClick={() => paginate(number)}
            >
              <p
                style={{
                  color: currentPage === number ? '#FF7A00' : '#000',
                  width: 25,
                  height: 25,
                  padding: '0px 1px 3px',
                }}
              >
                {number}
              </p>
            </div>
          ))}

          <Button onClick={handleNextBtn}>
            <p style={{ marginLeft: 15 }}>다음</p>
            <img
              src={nextIcon}
              style={{ marginLeft: 7, paddingTop: 3 }}
              alt="다음"
            />
          </Button>
        </>
      )}
    </div>
  );
}

export default Pagination;

const Button = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
